import { COMPONENTS, CoreConfig, DeepPartial, SLOTS } from '@empathybroker/ebx-gluon';

export const MOBILE_CORE: DeepPartial<CoreConfig> = {
  components: {
    EmptySearch: null,
    ScrollToTop: null,
    Close: {
      order: 0,
      data: {
        slot: SLOTS.template.header
      }
    },
    ResultsNumber: {
      order: 1,
      data: {
        slot: SLOTS.template.footer
      }
    },
    Sort: {
      order: 2,
      data: {
        slot: SLOTS.template.footer
      }
    },
    SortList: {
      component: null
    },
    ToggleFacetsGroups: {
      order: 3,
      data: {
        slot: SLOTS.template.footer
      }
    }
  }
};

export const DESKTOP_CORE: DeepPartial<CoreConfig> = {
  template: COMPONENTS.TEMPLATES.MaxWidthTemplate,
  components: {
    CdlLogo: {
      order: 0,
      component: 'CdlLogo',
      data: {
        slot: SLOTS.template.header
      }
    },
    Close: {
      order: 1
    },
    CdlCrossClose: {
      component: 'CdlCrossClose',
      order: 3,
      data: {
        slot: SLOTS.template.header
      }
    },
    SearchBox: {
      order: 4
    },
    RelatedTags: {
      order: 5
    },
    ResultsNumber: {
      data: {
        slot: SLOTS.template.toolbar
      }
    },
    Sort: {
      data: {
        slot: SLOTS.template.toolbar
      }
    },
    ColumnsPicker: {
      data: {
        slot: SLOTS.template.toolbar
      }
    },
    SpellCheck: {
      data: {
        slot: SLOTS.template.toolbar
      }
    }
  }
};
